import React from 'react';
import { Edit, ReferenceField, required, SaveButton, SimpleForm, TextField, TextInput, Toolbar } from 'react-admin';
import { CustomEditActions } from './CustomActions';
import { BannerTemplatesTitle } from './BannerTemplatesTitle';
import { BooleanInputWithDescription } from '../../components/BooleanInputWithDescription';

export const ConsentBannerEdit = (props) => (
  <Edit title={<BannerTemplatesTitle/>} {...props} actions={<CustomEditActions/>}>
    <SimpleForm toolbar={<CustomToolbar/>}>
      <TextInput source="name" validate={required()}/>

      <ReferenceField label="Account" source="account" reference="accounts">
        <TextField source="name"/>
      </ReferenceField>

      <TextInput multiline source="html" options={{ maxRows: '10' }} fullWidth/>

      <TextInput multiline source="css" options={{ maxRows: '10' }} fullWidth/>

      <TextInput multiline source="js" options={{ maxRows: '10' }} fullWidth/>

      <TextInput source="displayPopUpFunctionName"/>

      <TextInput source="hidePopUpFunctionName"/>

      <BooleanInputWithDescription label="Publish now" source="publishNow" className="consent-banner-edit-publish-now-switch">
        Check it if you would like to publish changes right away for every related website, otherwise, leave it unchecked and changes will be
        published with next cookie declaration update
      </BooleanInputWithDescription>
    </SimpleForm>
  </Edit>
);

const CustomToolbar = props => (
  <Toolbar {...props} >
    <SaveButton className="consent-banner-edit-save-button"/>
  </Toolbar>
);
